// BaseClassificacaoInstrumentoTreeview.js

export default {
  BaseClassificacaoInstrumentoTreeview: {
    children: '1 item | {count} itens'
  }
}
